import { createTheme } from "@mui/material/styles";

export const temaTabela = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "13px",
          padding: "4px 16px", // aplica em todas
        },
        head: {
          backgroundColor: "#bebebe",
          color: "black",
          fontWeight: 560,
          padding: "8px 16px",
          position: "sticky",
          top: 0,
          zIndex: 2,
        },
        body: {
          fontSize: "13px",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: "35px",
          "&:nth-of-type(odd)": {
            backgroundColor: "rgba(0, 0, 0, 0.04)", // igual ao action.hover
          },
          "&:last-child td, &:last-child th": {
            border: 0,
          },
        },
      },
    },
  },
});
